/**
 * Хранилище для страницы проектов (участки, переданные субъектам РФ)
 */

import { defineStore } from 'pinia';
import axios from 'axios';
import { stringify } from 'query-string';

const API_URL = {
    filters: '/api/v2.1/land/transferred/filters/',
    items: '/api/v2.1/land/transferred/list/',
    markers: '/api/v2.1/land/transferred/map/',
    itemInfo: '/api/v2.1/land/transferred/item/',
    chartsData: '/api/v2.1/land/transferred/stats/'
    // itemExcel: '/api/v2.1/land/transferred/cad/',
    // filters: 'img/projectsFilters.json',
    // items: 'img/projectsList.json',
    // markers: 'img/projectsMap.json',
    // itemInfo: 'img/projectsMapBalloon.json.id=',
};

// eslint-disable-next-line import/prefer-default-export
export const useTransferredObjectsStore = defineStore('transferredObjects', {
    state: () => ({
        filters: {},
        items: [],
        markers: [],
        chartsData: {},
        activeMarker: null,
        nav: {},
        localFilters: {},
        pagination: {
            page: 1,
            'page-size': 4,
        },
        stats: {},
        fetch: {
            isFetching: false,
            isFetched: false,
        },
    }),

    getters: {
        currentPage: (state) => state.nav.NavPageNomer || state.pagination.page,
        pageCount: (state) => state.nav.NavPageCount || state.pagination.page,
        // navRecordCount: (state) => state.nav.NavRecordCount || state.pagination['page-size'],
        navRecordCount: (state) => state.nav.NavRecordCount || 0,
        navPageSize: (state) => state.nav.NavPageSize || state.pagination['page-size'],
    },

    actions: {
        async fetchFilters() {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;

            return axios
                .get(API_URL.filters)
                .then((response) => {
                    if (response.data.success) {
                        this.setDataFilters(response.data.data);
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },
        setDataFilters(data) {
            this.filters = data;
            this.fetch.isFetched = true;
        },
        /**
         * Получение списка объектов, с учетом фильтров
         * @returns {Promise<unknown>}
         */
        async fetchItems(append = false) {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            const params = {
                ...this.pagination,
                ...this.localFilters,
            };
            const URIParams = `?${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;
            return axios
                .get(API_URL.items + URIParams)
                .then((response) => {
                    if (response.data.success) {
                        if (append) {
                            this.items = [...this.items, ...response.data.data];
                        } else {
                            this.items = response.data.data;
                        }
                        this.nav = response.data.nav;
                        this.stats = response.data.stats;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },
        setLocalFilter(filters) {
            this.localFilters = filters;
            this.pagination.page = 1;
        },
        changePage(n) {
            this.pagination.page = n;
        },
        async fetchMapItems() {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            const params = {
                ...this.localFilters,
            };
            const URIParams = `?${stringify(params, {
                arrayFormat: 'comma',
                skipNull: true,
                skipEmptyString: true,
            })}`;
            return axios
                .get(API_URL.markers + URIParams)
                .then((response) => {
                    if (response.data.success) {
                        this.markers = response.data.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },
        async fetchMarkerItem(id) {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            return axios
                .get(`${API_URL.itemInfo + id}/`)
                .then((response) => {
                    if (response.data.success) {
                        this.activeMarker = response.data.data;
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        },

        async fetchChartsData() {
            this.fetch.isFetching = true;
            this.fetch.isFetched = false;
            return axios
                .get(API_URL.chartsData)
                .then((response) => {
                    if (response.data.success) {
                        this.chartsData = response.data.data;
                    }
                })
                .catch((error) => {
                    console.log('error-fetch', error);
                    this.fetch.isFetched = false;
                })
                .finally(() => {
                    this.fetch.isFetching = false;
                });
        }
    },
});
